import HostnameTable from "Components/HostnameTable";
import { selectHostnames } from "Data/Redux/Slices/Hostnames";
import { useAppSelector } from "Data/Redux/Store";
import { memo } from "react";
import "Components/Dashboards/UserDashboard/UserDashboard.less";

function UserDashboard() {
	const hostnames = useAppSelector(selectHostnames);

	return (
		<div className="user-dashboard">
			<div className="table-container">
				<HostnameTable hostnames={ hostnames } />
			</div>
		</div>
	);
}

export default memo(UserDashboard);
